/** Category glyphs from the prototype (icon grid, placeholders, heroes). Keyed by icon or slug. */
import type { ReactNode } from 'react'

const G: Record<string, ReactNode> = {
  textiles: (
    <>
      <path d="M17 6h14l9 7-5 7-4-3v25H17V17l-4 3-5-7z" />
      <path d="M19 6c1 3 3 5 5 5s4-2 5-5" />
    </>
  ),
  supermarket: (
    <>
      <path d="M9 16h30l-3 26H12z" />
      <path d="M17 16v-3a7 7 0 0 1 14 0v3" />
      <path d="M18 27c3 3 9 3 12 0" />
    </>
  ),
  mobiles: (
    <>
      <rect x="14" y="5" width="20" height="38" rx="4" />
      <path d="M21 37h6" />
    </>
  ),
  electronics: (
    <>
      <rect x="6" y="9" width="36" height="24" rx="3" />
      <path d="M18 41h12M24 33v8" />
    </>
  ),
  fancy: (
    <>
      <circle cx="24" cy="28" r="13" />
      <circle cx="24" cy="28" r="8" />
      <path d="M19 8h10l3 5-8 6-8-6z" />
    </>
  ),
  footwear: (
    <>
      <path d="M6 32V14h10c0 6 5 9 12 10l10 2c3 1 4 3 4 6v3H6z" />
      <path d="M6 35h36" />
    </>
  ),
  bakery: (
    <>
      <path d="M8 24h32v16H8z" />
      <path d="M8 30c4 3 8 3 12 0s8-3 12 0 6 2 8 0" />
      <path d="M16 24v-6M24 24v-8M32 24v-6" />
      <path d="M16 15v-2M24 13v-2M32 15v-2" />
    </>
  ),
  jewellery: (
    <>
      <path d="M10 10c2 14 8 20 14 20s12-6 14-20" />
      <path d="M18 30l6 10 6-10" />
    </>
  ),
  'home-and-kitchen': (
    <>
      <path d="M9 20h30v14a8 8 0 0 1-8 8H17a8 8 0 0 1-8-8z" />
      <path d="M4 22h5M39 22h5M18 20v-4h12v4M22 12h4" />
    </>
  ),
  stationery: (
    <>
      <path d="M32 6l10 10-22 22H10V28z" />
      <path d="M27 11l10 10M10 38l-2 4 4-2" />
    </>
  ),
  pharmacy: (
    <>
      <rect x="8" y="8" width="32" height="32" rx="8" />
      <path d="M24 16v16M16 24h16" />
    </>
  ),
  ayurveda: (
    <>
      <path d="M24 42V22" />
      <path d="M24 22c0-8 6-14 14-14 0 8-6 14-14 14z" />
      <path d="M24 30c0-6-5-11-12-11 0 6 5 11 12 11z" />
    </>
  ),
  'fruits-and-vegetables': (
    <>
      <circle cx="24" cy="28" r="13" />
      <path d="M24 15c0-4 2-7 6-8M24 15c-3-3-7-3-9-1" />
    </>
  ),
  'meat-and-fish': (
    <>
      <path d="M6 24c6-8 16-10 26-4l8-6v20l-8-6c-10 6-20 4-26-4z" />
      <circle cx="14" cy="22" r="1.5" />
    </>
  ),
  'beauty-and-personal-care': (
    <>
      <rect x="17" y="18" width="14" height="24" rx="3" />
      <path d="M20 18v-6h8v6M22 12V7h4v5" />
    </>
  ),
  'hardware-and-electricals': (
    <>
      <path d="M28 8a8 8 0 0 0-7 11L8 32l8 8 13-13a8 8 0 0 0 11-7l-5 5-6-6z" />
    </>
  ),
  furniture: (
    <>
      <path d="M10 22v-6a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v6" />
      <path d="M6 24a4 4 0 0 1 8 0v4h20v-4a4 4 0 0 1 8 0v10H6z" />
      <path d="M10 34v6M38 34v6" />
    </>
  ),
  'toys-and-baby': (
    <>
      <circle cx="24" cy="26" r="12" />
      <circle cx="14" cy="12" r="5" />
      <circle cx="34" cy="12" r="5" />
      <path d="M19 28c3 3 7 3 10 0" />
    </>
  ),
  'sports-and-fitness': (
    <>
      <circle cx="24" cy="24" r="16" />
      <path d="M24 16l7 5-3 8h-8l-3-8z" />
      <path d="M24 8v8M38 19l-7 2M33 37l-5-8M15 37l5-8M10 19l7 2" />
    </>
  ),
  'bags-and-luggage': (
    <>
      <rect x="8" y="16" width="32" height="24" rx="4" />
      <path d="M18 16v-4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4M8 26h32" />
    </>
  ),
  'watches-and-opticals': (
    <>
      <circle cx="24" cy="24" r="10" />
      <path d="M24 18v6l4 3M18 15l2-9h8l2 9M18 33l2 9h8l2-9" />
    </>
  ),
  'agriculture-and-garden': (
    <>
      <path d="M12 30h24l-3 12H15z" />
      <path d="M24 30V16M24 22c-6 0-9-4-9-8 6 0 9 4 9 8zM24 18c0-5 4-9 10-9 0 5-4 9-10 9z" />
    </>
  ),
  'auto-accessories': (
    <>
      <circle cx="12" cy="32" r="6" />
      <circle cx="36" cy="32" r="6" />
      <path d="M12 32l8-12h8l8 12M20 20l-2-6h-4M28 20h6" />
    </>
  ),
  store: (
    <path d="M8 18l3-10h26l3 10M8 18h32v4a6 6 0 0 1-10.6 3.8A6 6 0 0 1 24 28a6 6 0 0 1-5.4-2.2A6 6 0 0 1 8 22zM10 26v14h28V26M20 40v-8h8v8" />
  ),
}
G.home_kitchen = G['home-and-kitchen']

function hasGlyph(key: string | null | undefined): boolean {
  return !!key && key in G
}

export function CategoryGlyph({
  icon,
  slug,
  size = 28,
}: {
  icon?: string | null
  slug?: string | null
  size?: number | string
}) {
  const key = hasGlyph(icon) ? icon! : hasGlyph(slug) ? slug! : 'store'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.4}
      strokeLinejoin="round"
      strokeLinecap="round"
      aria-hidden="true"
    >
      {G[key]}
    </svg>
  )
}
